/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const selectPassportOffer = ({
    passportData = {}, abData = {}, signInData = {}, campaignData = {}, flags = {}, activeABTests = {},
}) => {
    let sku = passportData?.item_id;
    let price = passportData?.price;

    if (abData?.passport_item_sku && abData?.term_for_enrolment_page && abData?.price) {
        sku = abData.passport_item_sku;
        price = abData.price;
    }
    if (signInData?.itemSku && signInData?.passportEnrolmentTerm && signInData?.price) {
        sku = signInData.itemSku;
        price = signInData.price;
    }

    const campaignApplied = Boolean(campaignData?.itemSku && campaignData?.passportEnrolmentTerm && campaignData?.price);
    if (campaignApplied) {
        sku = campaignData.itemSku;
        price = campaignData.price;
    }

    if (!campaignData?.enable && flags['passport-google-optimize']
        && (activeABTests?.loaded || activeABTests?.timeout)
        && passportData?.ab_testing?.variant?.passport_referenced_sku?.[0]?.price
        && passportData?.ab_testing?.control?.passport_referenced_sku?.[0]?.price) {
        const selected = activeABTests.passportSkuTest === 'Rule_One'
            ? passportData.ab_testing.variant.passport_referenced_sku[0]
            : passportData.ab_testing.control.passport_referenced_sku[0];
        if (selected?.item_sku) {
            sku = selected.item_sku;
            price = selected.price;
        }
    }

    return { sku, price, campaignApplied };
};

export default selectPassportOffer;
